type LoggerLike = {
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
  debug: (...args: unknown[]) => void;
  level?: string;
};

let activeLogger: LoggerLike = console;

const wrapStringContext = (args: unknown[]): unknown[] => {

  const [message, context, ...rest] = args;

  return typeof context === 'string' ? [message, { context }, ...rest] : args;

};

export const Logger = {
  info: (...args: unknown[]) => activeLogger.info(...wrapStringContext(args)),
  warn: (...args: unknown[]) => activeLogger.warn(...wrapStringContext(args)),
  error: (...args: unknown[]) => activeLogger.error(...wrapStringContext(args)),
  debug: (...args: unknown[]) => activeLogger.debug(...wrapStringContext(args)),
};

export const registerLogger = (logger: LoggerLike, verbosity: string) => {

  if (logger?.level && verbosity) {

    logger.level = verbosity;
  
  }

  activeLogger = logger;

};
